import React from "react";
import { Skeleton } from "@mui/material";
import { ISocieteDetails } from "../../../models/interfaces/ISociete";
import MarqueBloc1 from "./MarqueBloc1";
import MarqueBloc2 from "./MarqueBloc2";
import MarqueBloc3 from "./MarqueBloc3";
import MarqueBloc4 from "./MarqueBloc4";
import MarqueBloc5 from "./MarqueBloc5";
import { Link } from "react-router-dom";
interface IProps {
  //navigatorPath: string;
  MarqueResult: ISocieteDetails|undefined;
  isFetchingMarqueResult:boolean;
  btnModifierVisible:boolean;
}
//navigatorPath
const MarqueDetails: React.FC<IProps> = ({ MarqueResult,isFetchingMarqueResult,btnModifierVisible }) => {
 
   return (
    <>
    
    {
      (!MarqueResult ||isFetchingMarqueResult) ?  
      <div className="card pae-detail-pub-card">
          <div className="card-body pae-form-container row">
            <Skeleton variant="rectangular" className="col-12" height="500px" />
          </div>
      </div>
      :
    <>
     <div className="card pae-detail-pub-card ">
      <div className="card-body pae-form-container row">
        <div className="col-2 mt-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" fill="currentColor" className="bi bi-buildings mt-3 mb-2" viewBox="0 0 16 16">
          <path d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022M6 8.694 1 10.36V15h5zM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5z"/>
          <path d="M2 11h1v1H2zm2 0h1v1H4zm-2 2h1v1H2zm2 0h1v1H4zm4-4h1v1H8zm2 0h1v1h-1zm-2 2h1v1H8zm2 0h1v1h-1zm2-2h1v1h-1zm0 2h1v1h-1zM8 7h1v1H8zm2 0h1v1h-1zm2 0h1v1h-1zM8 5h1v1H8zm2 0h1v1h-1zm2 0h1v1h-1zm0-2h1v1h-1z"/>
        </svg>
          {btnModifierVisible && (
          <div className="card mt-1 mb-2" style={{ textAlign: 'left' }}>
                  <Link to={`/monorganisation/marquedetailsmessage/${MarqueResult?.Societe?.Id}`} className="App-link btn btn-secondary d-flex"> 
                    <i className="bi-pencil-square pe-2 App-icon-size" />
                    <div className="desktop-only-section">Modifier</div>
                  </Link>
                </div>
          )}
        </div>
        <div className="col-10 mt-2">
          <MarqueBloc1 MarqueResult={MarqueResult}></MarqueBloc1>
          <MarqueBloc2 MarqueResult={MarqueResult}></MarqueBloc2>
        </div>   
      </div>
        <div className="card-body pae-form-container row">
        <div className="col-sm-6 mt-2">
            <MarqueBloc3 MarqueResult={MarqueResult}></MarqueBloc3>
            <MarqueBloc5 MarqueResult={MarqueResult}></MarqueBloc5>
        </div>
        <div className="col-sm-6 mt-2">
        {MarqueResult?.LiensCommercialisationParType?.map((typeLienCommercialisation, index) => (
                <><MarqueBloc4 key={index} LiensCommercialisationParType={typeLienCommercialisation}></MarqueBloc4></>
            ))}
            
           
        </div>
      </div>
    </div>
   
    </>
    }
    </>
  );
};

export default MarqueDetails
